import React from "react";
import PolicyLayout from "./PolicyLayout";

const TermsConditions: React.FC = () => {
  const termsSections = [
    {
      title: "1. Introduction",
      content:
        `${import.meta.env.VITE_COMPANY_NAME} provides personal loans to salaried individuals under the regulatory oversight of ${import.meta.env.VITE_COMPANY_NBFC} Our goal is to offer instant, easy, and transparent financial solutions.`,
    },
    {
      title: "2. Eligibility Criteria",
      content:
        "To apply for a personal loan, you must meet the following requirements:",
      list: [
        "Be at least 21 years old and not older than 60 at the time of application.",
        "Be a salaried individual with stable income from a recognized organization.",
        `Meet the minimum monthly income criteria defined by ${import.meta.env.VITE_COMPANY_NBFC}`,
        "Be a resident of India with a satisfactory credit score and financial history.",
      ],
    },
    {
      title: "3. Loan Application Process",
      content:
        `The process includes registration, application form, document submission, and credit assessment. Approval is solely at the discretion of ${import.meta.env.VITE_COMPANY_NBFC}`,
    },
    {
      title: "4. Loan Terms",
      content:
        "Loan amount, interest rate, and repayment schedule are determined based on applicant profile. Interest rate remains fixed during the tenure.",
    },
    {
      title: "5. Fees and Charges",
      content:
        "Applicable fees may include processing fee, late payment charges, Early repayment may attract prepayment penalties, etc., as mentioned in the loan agreement.",
    },
    {
      title: "6. Loan Disbursement",
      content:
        `Once approved and formalities completed, the loan amount will be credited to your bank account. Disbursement timelines may vary, but ${import.meta.env.VITE_COMPANY_NAME} strives for quick processing.`,
    },
    {
      title: "7. Loan Repayment",
      content:
        "Repayments must follow the schedule outlined in the loan agreement. Payments may be auto-debited via NACH or through digital methods such as UPI. Early repayment may attract foreclosure charges.",
    },
    {
      title: "8. Default and Consequences",
      content:
        "Failure to repay on time may lead to late fees, negative reporting to credit bureaus, and possible legal action.",
    },
    {
      title: "9. Cancellation of Loan",
      content:
        "Applications may be cancelled before disbursement. Once disbursed, cancellation is not possible. Prepayment is allowed as per agreement terms.",
    },
    {
      title: "10. Data Privacy and Security",
      content:
        "All information is handled securely in compliance with data protection laws and used only for loan processing and communication.",
    },
    {
      title: "11. User Responsibilities",
      content:
        "You must provide accurate details during registration and application. Misrepresentation may lead to denial of service or legal action.",
    },
    {
      title: "12. Amendments to Terms",
      content:
        "We may update these terms anytime. Updates will be posted on our website, and it is your responsibility to stay informed.",
    },
    {
      title: "13. Dispute Resolution",
      content:
        "Disputes will first be attempted to resolve amicably. If unresolved, they fall under the jurisdiction of courts in Delhi, India.",
    },
    {
      title: "14. Limitation of Liability",
      content:
        `${import.meta.env.VITE_COMPANY_NBFC} is not liable for any loss, damage, or inconvenience arising from the use of this website or services, except as expressly mentioned in the loan agreement.`,
    },
    {
      title: "15. Governing Law",
      content:
        "These Terms and Conditions are governed by and construed in accordance with the laws of India.",
    },
  ];

  return (
    <PolicyLayout 
      title="Terms & Conditions" 
      subtitle={`Welcome to ${import.meta.env.VITE_COMPANY_NAME}. By accessing our platform, you agree to comply with our professional standards and the regulatory guidelines provided below.`}
      badge="Legal Vault 📜"
    >
      {termsSections.map((section, idx) => (
        <div key={idx} className="space-y-6">
          <h2 className="text-3xl font-black text-[#0F172A] tracking-tight">
            {section.title}
          </h2>

          {section.content && (
            <p className="text-[var(--text-secondary)] text-lg leading-relaxed font-medium">
              {section.content}
            </p>
          )}
          
          {section.list && (
            <ul className="space-y-4">
              {section.list.map((li, i) => (
                <li key={i} className="flex items-start gap-3 text-[var(--text-secondary)] text-lg font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)] mt-2.5 flex-shrink-0" />
                  {li}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </PolicyLayout>
  );
};

export default TermsConditions;
